import actions from './actions'
import feedback from './metaData/feedback'
export default {
  state: feedback,
  actions
}
